import { ChevronRight } from 'lucide-react';
import { triggerHaptic } from '../../lib/haptics';
import { InsetGroup, PRESS, SectionHeader } from './insightsUi';

export type MoreAnalysisPage = 'report' | 'timeline' | 'bowel' | 'ingredients' | 'safe';

const ROWS: Array<{ page: MoreAnalysisPage; label: string }> = [
  { page: 'report', label: 'Full report for your doctor' },
  { page: 'timeline', label: 'Meal & symptom timeline' },
  { page: 'bowel', label: 'Bowel movements' },
  { page: 'ingredients', label: 'All ingredients' },
  { page: 'safe', label: 'Safe meals' },
];

export interface MoreAnalysisListProps {
  onOpen: (page: MoreAnalysisPage) => void;
}

/** "More analysis": navigation rows into the existing detail sections. */
export function MoreAnalysisList({ onOpen }: MoreAnalysisListProps) {
  return (
    <section>
      <SectionHeader>More analysis</SectionHeader>
      <InsetGroup>
        {ROWS.map((r) => (
          <button
            key={r.page}
            data-more-page={r.page}
            type="button"
            onClick={() => {
              triggerHaptic('selection');
              onOpen(r.page);
            }}
            className={`flex w-full items-center gap-3 px-4 py-3 text-left ${PRESS}`}
          >
            <span className="flex-1 text-base text-slate-950 dark:text-white">{r.label}</span>
            <ChevronRight aria-hidden="true" className="w-4 h-4 shrink-0 text-slate-400 dark:text-zinc-500" />
          </button>
        ))}
      </InsetGroup>
    </section>
  );
}
